import React, { useEffect, useState } from 'react';

const WidgetPreviewDisplay = () => {
    const [backgroundImage, setBackgroundImage] = useState(null);

    useEffect(() => {
        // Get background image from sessionStorage
        const storedImage = sessionStorage.getItem('widget_preview_background');
        if (storedImage) {
            setBackgroundImage(storedImage);

            const img = new Image();
            img.onload = () => {
                console.log(`Preview image loaded: ${img.naturalWidth}x${img.naturalHeight}`);
            };
            img.src = storedImage;
        }

        // Pre-inject CSS to ensure styles are ready before widget HTML is created
        if (!document.getElementById('chat-widget-stylesheet')) {
            const cssLink = document.createElement('link');
            cssLink.id = 'chat-widget-stylesheet';
            cssLink.rel = 'stylesheet';
            cssLink.href = '/widget.css';
            document.head.appendChild(cssLink);
        }

        // Load widget script
        const loadWidget = () => {
            const script = document.createElement('script');
            script.src = '/widget.js';
            script.async = true;

            script.onload = () => {
                console.log('Widget script loaded');

                setTimeout(() => {
                    if (window.ChatWidget) {
                        const backendUrl = process.env.REACT_APP_API_BASE_URL?.replace('/api', '');
                        const activeAiAgentId = localStorage.getItem('activeAiAgentId') || 'b8d8cf9e-3b2d-4f10-91a5-e3d81b2f7c03';

                        const syncedConfigJson = sessionStorage.getItem('widget_preview_config');
                        const syncedConfig = syncedConfigJson ? JSON.parse(syncedConfigJson) : {};

                        const authToken = (() => {
                            try { return JSON.parse(sessionStorage.getItem('user') || localStorage.getItem('user') || '{}').token; } catch { return undefined; }
                        })();

                        window.ChatWidget.init({
                            apiUrl: backendUrl,
                            aiAgentId: activeAiAgentId,
                            ...syncedConfig,
                            isPreview: true,
                            authToken
                        });

                        console.log(`Widget initialized for agent ${activeAiAgentId}`);
                    } else {
                        console.error('ChatWidget not found on window object');
                    }
                }, 500);
            };

            script.onerror = () => {
                console.error('Failed to load widget script');
            };

            document.body.appendChild(script);
        };

        loadWidget();

        return () => {
            const widgetContainer = document.querySelector('.chat-widget-container');
            if (widgetContainer) {
                widgetContainer.remove();
            }
        };
    }, []);

    return (
        <div
            className="w-screen h-screen m-0 p-0 overflow-hidden relative"
            style={
                backgroundImage
                    ? {
                          backgroundImage: `url(${backgroundImage})`,
                          backgroundSize: 'cover',
                          backgroundPosition: 'center',
                          backgroundRepeat: 'no-repeat',
                      }
                    : {
                          backgroundColor: '#ffffff',
                      }
            }
        />
    );
};

export default WidgetPreviewDisplay;
